<span [innerHTML]="'common.disallowed-optimization.message' | translate"></span>
